import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Typography } from '@material-ui/core';
import CancelButton from '../../../components/Buttons/Cancel/CancelButton';
import useStyles from './styles';

function Header({ className, ...rest }) {
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justifyContent="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Grid container spacing={1}>
          <Grid item>
            <Typography variant="h3" color="textSecondary">
              Crear
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h3" color="textPrimary">
              Link de Pago
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <CancelButton href="/links-de-pago" variant="contained">
          Cancelar
        </CancelButton>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
